import React from 'react'
import { Box, Typography, withStyles } from '@material-ui/core'
import styles from './styles'

// Sunday's quote above the comparison table on the Enterprise tab. Same copy
// and pale-tint testimonial style as the enterprise panels on the website.
const CustomerQuote = ({ classes }) => (
  <Box component="figure" className={classes.root}>
    <Box className={classes.photoWrap}>
      <img
        src="/assets/pricing/eric-bloomquist-sunday.jpg"
        alt="Eric Bloomquist, sunday"
        className={classes.photo}
      />
    </Box>
    <Box>
      <Box className={classes.brandRow}>
        <span role="img" aria-label="sunday logo" className={classes.logo} />
        <span className={classes.stat}>
          <span className={classes.statValue}>~75%</span>
          <span className={classes.statLabel}>completion rate</span>
        </span>
      </Box>
      <Box component="blockquote" className={classes.quote}>
        <Typography component="p" className={classes.quoteText}>
          We embedded Mini Course Generator straight into the sunday server app
          over the REST API in days, not months.
        </Typography>
        <Typography
          component="p"
          className={classes.quoteText}
          style={{ marginTop: 16 }}
        >
          We train our partners and their staff without ever leaving the app,
          with a team that actually built the custom pieces we needed.
        </Typography>
      </Box>
      <Box component="figcaption" className={classes.caption}>
        <Typography className={classes.name}>Eric Bloomquist</Typography>
        <Typography className={classes.role}>
          Product Manager - sunday
        </Typography>
      </Box>
    </Box>
  </Box>
)

export default withStyles(styles)(CustomerQuote)
